export default __webpack_public_path__ + "static/media/md-card-bg-python.f3e61e9a.png";